// extracted by mini-css-extract-plugin
export var avatarContainer = "_5a-1";
export var largeAvatarContainer = "_5a-2";
export var smallAvatarContainer = "_5a-0";